import { GatewayUserModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/users/models/outputs/gateway-user.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { UserListCustomerCell } from './user-list-customer.cell';
import { UserListCustomerHeader } from './user-list-customer.header';

export const UserListCustomerColumn: IdentifiedColumnDef<
  GatewayUserModel,
  GatewayUserModel['customer']
> = {
  enableSorting: false,
  header: UserListCustomerHeader,
  cell: UserListCustomerCell,
};
